import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';

@Component({
    selector: 'cmps-text-filter',
    template: ` <ng-content select="cmps-text-filter-header"></ng-content>
        <div class="cmps-text-filter--search-box">
            <input
                type="text"
                [placeholder]="placeholder ?? ''"
                [ngModel]="text"
                (ngModelChange)="_textChangeDebounceSubj?.next($event)"
            />
        </div>
        <div class="cmps-text-filter--item-wrapper">
            <ng-content select="cmps-text-filter-item"></ng-content>
        </div>`,
    host: {
        class: 'cmps-text-filter',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class TextFilterComponent implements OnInit, OnDestroy {
    @Input() placeholder: string;
    @Input() text: string;
    @Output() textChange: EventEmitter<string>;

    /** @private */
    _textChangeDebounceSubj: Subject<string>;

    private _textChangeDebounceSub: Subscription;

    constructor() {
        this.textChange = new EventEmitter();
    }

    ngOnInit(): void {
        this._textChangeDebounceSubj = new Subject();
        this._textChangeDebounceSub = this._textChangeDebounceSubj
            .asObservable()
            .pipe(
                debounceTime(500),
                tap((str) => {
                    this.textChange.emit(str);
                }),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.textChange?.emit(null);
        this.textChange?.complete();
        this._textChangeDebounceSub?.unsubscribe();
    }
}
